import React, { FC } from 'react';
import FreeCreditsHistoryView from './FreeCreditsHistoryView';
import { useFreeCreditsHistoryController } from '../../../controllers';
import { FreeCreditsHistoryProps } from '../../../types';

const FreeCreditsHistory: FC<FreeCreditsHistoryProps> = props => {
  const viewModel = useFreeCreditsHistoryController(props);
  return <FreeCreditsHistoryView {...viewModel} />;
};

export default FreeCreditsHistory;
